export enum ChartToolTipTrigger {
    focus,
    none,
    selection
}